import React, { useGlobal, useEffect, setGlobal } from "reactn";
import { createBrowserHistory } from "history";
import Masonry from 'react-masonry-css'
 
//...
 


// const history = createBrowserHistory()
// import './App.scss';

const WorkSingle = (props) => {
  const idWork = useGlobal('selectedWork');
  const workItems = useGlobal('workItems');

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const displayImages = (post) => {

    const breakpointColumnsObj = {
      default: 2,
      1100: 2,
      700: 2,
      576: 1
    };
    
    const postList = post[0].acf.work_images.map(post => {
        return ( 
          <div>
            <img src={post.image.sizes.large} />
          </div>
        );
      });
    
      return ( 
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column">
          {postList}
        </Masonry>
      )
  }
    
  


  const displayItem = (post) => {
    
    if (post[0]) {

      return (
        <div className="home-page">
          <div className="row">
            <div className="col-12">
                <div className="intro-text" dangerouslySetInnerHTML={{__html: post[0].content.rendered}}>
                </div>
            </div>
          </div>
          <div className="row">
            {displayImages(post)}
          </div>
        </div>
      )
            
    }
    
  }

  const updateSelectedItem = () => {
    console.log(idWork)
    if(workItems[0].length > 1) {
        const workArray = workItems[0]
        const items = workArray.filter(item => {
          if (item.id === idWork[0]) {
            return true;
          }
      })
      const htmlLayout = displayItem(items)
      return htmlLayout;
    }
  }


  if (idWork[0] !== '') {
    return ( 
      updateSelectedItem()
    )
  } else if(workItems[0]) {
    const postName = window.location.pathname.substring(7)
    const selectedWorkByURL = workItems[0].filter((post)=> {
      return post.slug === postName;
    })
    setGlobal({selectedWork:selectedWorkByURL[0].id})
    updateSelectedItem();
  } else {
    return (
      <div className="home-page">
        <div className="row">
          <div className="col-12">
              <div className="intro-text">
                <p>loading...</p>        
              </div>
          </div>
        </div>
        
      </div>
    )
  }
  
}

export default WorkSingle;